'use client';

import type React from 'react';

import { AuthPanel, AuthPanelColumn, AuthPanelVariant } from '@vs-shop/commerce-ui/authPanel';

import { useAppSearchParams } from '../../shared/router/AppRouterContext';

import { callbackUrlQueryParam, isAllowedCallbackUrl } from '../../config/callbarkUrl';
import { Url } from '../../route/router';

import { navigateFullPage } from '../../utils/router';

import LoginForm from './LoginForm';

import { authModalAtom, AuthModalMode } from '@vs-shop/engine/atom/ui/authModal';
import { useAtomSet } from '@effect/atom-react';

type Props = {
  children: React.ReactNode;
};

export default function LoginWrapper({ children }: Props) {
  const setAuthModal = useAtomSet(authModalAtom);
  const handleResetPasswordOpen = () => {
    setAuthModal({ isOpen: true, mode: AuthModalMode.resetPassword });
  };

  const searchParams = useAppSearchParams();
  const callbackUrlParam = searchParams.get(callbackUrlQueryParam);

  const isCallbackUrlAllowed = callbackUrlParam !== null && isAllowedCallbackUrl(callbackUrlParam);
  const callbackUrl = isCallbackUrlAllowed ? callbackUrlParam : Url.accountDashboard;

  const onSuccess = () => {
    navigateFullPage(callbackUrl);
  };

  const onSwitchToRegister = () => {
    /* empty */
  };

  const onSwitchToResetPassword = () => {
    handleResetPasswordOpen();
  };

  return (
    <AuthPanel variant={AuthPanelVariant.PLAIN} data-slot="login-page">
      <AuthPanelColumn>
        {children}

        <LoginForm
          onSuccessAction={onSuccess}
          onSwitchToRegisterAction={onSwitchToRegister}
          onSwitchToResetPasswordAction={onSwitchToResetPassword}
          displaySwitchToRegister={false}
        />
      </AuthPanelColumn>
    </AuthPanel>
  );
}
